import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css';
import './Cards.css';
import './components/SearchBar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/Footer.css'
import Icon from './TTE_Icon.png'
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import Home from './components/Home';
import BodyBetrayal from './components/BodyBetrayal';
import BodyCAH from './components/BodyCAH'
import BodyEscapeCastle from './components/BodyEscapeCastle';
import BodyMunchkinDeluxe from './components/BodyMunchkinDeluxe';
import Dropdown from './dropdown.png'


import GameData from './components/Data.json'
import SearchBar from './components/SearchBar';
import { Link } from "react-router-dom";
import { useState } from 'react';
import { auth } from './components/firebase-config';
import { getAuth, signOut } from 'firebase/auth';

import Login from './components/Login';
import Profile from './components/Profile';
import BodyRedDragonInn from './components/BodyRedDragonInn';
import BodyCatan from './components/BodyCatan';
import BodySushiGo from './components/BodySushiGo';
import GameList from './components/GameList';
import Rankings from './components/Rankings';
import RankingsEditor from './components/RankingsEditor';
import TermsAndConditions from './components/TermsAndConditions';
import About from './components/About';
import BodyExplodingKittens from './components/BodyExplodingKittens';
import AccountDropdown from './components/AccountDropdown';
import ProfileEdit from './components/ProfileEdit';
import DropDownButton from './DropDownButton';


function App() {
  const [isAuth, setIsAuth] = useState(false);


  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }


  const signUserOut = () => {
    signOut(auth).then(() => {
      localStorage.clear()
      setIsAuth(false)
      const auth = getAuth();
      signOut(auth).then(() => {
        // Sign-out successful.

      }).catch((error) => {
        // An error happened.
      });

      window.location.pathname = "/";

    });
  };

  console.log(auth.currentUser)

  return (
    <div className="App">
      <body>
        <div className="Header">
          <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark ">
            <a><img src={Icon} style={{ width: '50px', marginLeft: '10px' }}></img></a>
            <a href="/" class="nav-mobile-button siteLogo navbar-brand navText">TableTop Encyclopedia</a>

            <a><DropDownButton /></a>
            <a href="/" class="nav-title siteLogo navbar-brand navText ">TableTop Encyclopedia</a>
            <div class="header-padding collapse navbar-collapse  justify-content-center" id="navbarNavAltMarkup">
              <div class="navbar-nav ">

                <Link to='About' className='link'><a class="nav-item nav-link purpleHover">About</a></Link>
                <Link to='/Ranking-By-Community'><a class="nav-item nav-link purpleHover" href="#">Rankings</a></Link>
                <Link to="/Game-List"><a class="nav-item nav-link purpleHover ">Games</a></Link>

              </div>
              <div>
                <a ><SearchBar placeholder="Enter name of Game" data={GameData} /></a>
              </div>
            </div>
            {/* <div className="inBetween nav-item dropdown">
              <ArrowDropDownCircleIcon/>
              </div> */}
            {!localStorage.isAuth ?

              //User Is Not Signed In
              <Link to="/login"><button type="button" class="loginButton btn btn-secondary">Log-in</button></Link>

              //User Is Signed In
              :
              <div className='account'>
                <AccountDropdown />
                <button type="button" class="loginButton btn btn-secondary" onClick={signUserOut}> Logout</button>

              </div>}
          </nav>

          <p class="bg-6">Find the perfect board game to play with your friends!</p>

        </div>
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='/Profile' element={<Profile />}></Route>
          <Route path='/Profile-Edit' element={<ProfileEdit />}></Route>
          <Route path='/Game-List' element={<GameList />}></Route>
          <Route path='/About' element={<About />}></Route>
          <Route path='/Ranking-By-Community' element={<Rankings />}></Route>
          <Route path='/Ranking-By-Editor' element={<RankingsEditor />}></Route>
          <Route path='Betrayal-At-House-3rd-Edition' element={<BodyBetrayal />}></Route>
          <Route path='Cards-Against-Humanity' element={<BodyCAH />}></Route>
          <Route path='Catan' element={<BodyCatan />}></Route>
          <Route path='Escape-The-Dark-Castle' element={<BodyEscapeCastle />}></Route>
          <Route path='Munchkin-Deluxe' element={<BodyMunchkinDeluxe />}></Route>
          <Route path='Red-Dragon-Inn' element={<BodyRedDragonInn />}></Route>
          <Route path='Sushi-Go' element={<BodySushiGo />}></Route>
          <Route path='Exploding-Kittens' element={<BodyExplodingKittens />}></Route>
          <Route path='Terms-and-Conditions' element={<TermsAndConditions />}></Route>
          <Route path='login' element={<Login setIsAuth={setIsAuth} />}></Route>
        </Routes>

        {/* Footer */}
        <div className='container-fluid footer-background'>
          <div className='container'>
            <div className='row '>
              <div className='col'>
                <h4>Games</h4>
                <div className='break'></div>
                <div className='subfooter'>
                  <Link to='/Game-List' className='link' onClick={() => { topFunction() }}><p>Games List</p></Link>
                  <Link to='/Ranking-By-Community' className='link' onClick={() => { topFunction() }}><p>Rankings</p></Link>
                  <p>Suggest A Game</p>
                </div>
              </div>
              <div className='col'>
                <h4>About</h4>
                <div className='break'></div>
                <div className='subfooter'>
                  <Link to='About' className='link'><p>About TTE</p></Link>
                  <p>About Rankings</p>
                  <p>About Creator</p>
                  <p>Donate</p>
                </div>
              </div>
              <div className='col'>
                <h4>Legal</h4>
                <div className='break'></div>
                <div className='subfooter'>
                  <Link to='/Terms-and-Conditions' className='link'><p>Terms and Conditions</p></Link>
                  <p>Privacy Policy</p>

                </div>
              </div>
              <div className='col'>
                <h4>Contact</h4>
                <div className='break'></div>
              </div>
            </div>
          </div>
          <div className='row bg-6'>
            <p className=' d-flex justify-content-lg-center'>Copyright ©2023 TableTop Encyclopedia. All rights reserved.</p>
          </div>
        </div>
      </body>

    </div>
  );
}
export default App
